/** @format */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BreakpointsService } from '@shared/data-access/services';
import { HmfSkeletonComponent } from '@dsg-tech/homefield-angular';
import { BreakPointNew } from '@shared/data-access/enums';

@Component({
	selector: 'compare-components-skeleton-specs-section',
	templateUrl: './skeleton-specs-section.component.html',
	styleUrl: './skeleton-specs-section.component.scss',
	imports: [HmfSkeletonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonSpecsSectionComponent {
	protected readonly breakpointsService = inject(BreakpointsService);

	protected readonly BreakPointNew = BreakPointNew;
}
